import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPTableDataFilterLoc =
	| 'SPTableDataHideFiltersTooltip'
	| 'SPTableDataShowFiltersTooltip'
	| 'SPTableDataClearFiltersTooltip'
	| 'SPTableDataSearchLabel';

export const spTableDataFilterLocs: LocDefs<SPTableDataFilterLoc> = {
	SPTableDataHideFiltersTooltip: {
		defaultValue: 'Hide filterable fields',
		description: 'Assistive text displayed on the toggle to hide filterable fields',
		displayPath: 'Data View|Hide Filterable Fields',
		displayType: 'Content',
		shared: true,
		portal: 'SP',
		feature: HubFeature.Core,
	},
	SPTableDataShowFiltersTooltip: {
		defaultValue: 'Show filterable fields',
		description: 'Assistive text displayed on the toggle to show filterable fields',
		displayPath: 'Data View|Show Filterable Fields',
		displayType: 'Content',
		shared: true,
		portal: 'SP',
		feature: HubFeature.Core,
	},
	SPTableDataClearFiltersTooltip: {
		defaultValue: 'Clear',
		description: 'Assistive text displayed on the clear filters button',
		displayPath: 'Data View|Clear Filters',
		displayType: 'Content',
		shared: true,
		portal: 'SP',
		feature: HubFeature.Core,
	},
	SPTableDataSearchLabel: {
		defaultValue: 'Search',
		description: 'Default label for the search field',
		displayPath: 'Data View|Search Field Label',
		displayType: 'Label',
		shared: true,
		portal: 'SP',
		feature: HubFeature.Core,
	},
};

export const LOC_KEYS = MapLocKeys<SPTableDataFilterLoc>(spTableDataFilterLocs);
export type SPTableDataFilterLocType = LocMap<SPTableDataFilterLoc>;
